import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const AccountNav = ({ currentPath }) => {
  const navigate = useNavigate();

  const navigationItems = [
    {
      id: 'profile',
      label: 'Profile',
      path: '/account-profile',
      icon: 'User',
      description: 'Personal information and settings'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-6 shadow-xl">
      <div className="mb-6">
        <h2 className="text-base font-medium text-white">Account Settings</h2>
        <p className="text-sm text-slate-300 mt-1">
          Manage your account preferences
        </p>
      </div>

      <ul className="space-y-2">
        {navigationItems?.map((item) => {
          const isActive = currentPath === item?.path;

          return (
            <li key={item?.id}>
              <button
                onClick={() => handleNavigation(item?.path)}
                className={`w-full flex items-start space-x-3 px-3 py-3 rounded-xl text-left transition-colors duration-200 ${
                  isActive
                    ? 'bg-blue-500/20 border border-blue-400/30'
                    : 'hover:bg-white/10 border border-transparent'
                }`}
              >
                <div className={`mt-0.5 ${isActive ? 'text-blue-300' : 'text-white/40'}`}>
                  <Icon name={item?.icon} size={18} />
                </div>
                <div className="flex-1">
                  <div className={`font-medium text-sm ${isActive ? 'text-blue-300' : 'text-white'}`}>
                    {item?.label}
                  </div>
                  <div className={`text-xs mt-0.5 ${isActive ? 'text-blue-400/70' : 'text-slate-400'}`}>
                    {item?.description}
                  </div>
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default AccountNav;